import {
  getRequestMap,
  postRequestMap,
  putRequestMap,
  deleteRequestMap,
  getRequestCustomThietbi
} from "dataProvider";
import _ from "lodash";

const isInvalidToken = e => {
  if (
    _.get(e, "response.status") === 401 &&
    _.get(e, "response.data.message").include(
      "Request failed with status code 401"
    )
  ) {
    return true;
  }
  return false;
};

export default class IOTUtilService {
  async get(api, config) {
    try {
      let response = await getRequestMap(api, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      ) {
        return {
          ...response.data,
          data: response.data.data
        };
      } else if (response.status === 401) {
        window.location.reload();
        return { errors: response.data.errors };
      }
      return {
        errors: response.data.errors
      };
    } catch (e) {
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          ...e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }

  async post(api, data, config) {
    try {
      let response = await postRequestMap(api, data, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          data: e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }
  async put(api, data, config) {
    try {
      let response = await putRequestMap(api, data, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.datadata.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          data: e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }
  async delete(api, data, config) {
    try {
      let response = await deleteRequestMap(api, data, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      console.log(e.response);
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          data: e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }
  async getCustom(api, config) {
    try {
      let response = await getRequestCustomThietbi(api, config);

      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };

      return {
        errors: response.data.errors
      };
    } catch (e) {
      if (e.response) {
        return {
          ...e.response,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }
}
